(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  /* Desktop hover-to-open for top-level header nav dropdowns (e.g. "Products").
     - Only activates on hover-capable, fine-pointer devices; touch/coarse pointers
       keep the native tap-to-open/close behavior (hover doesn't exist there).
     - ~120ms open delay avoids flicker on fast pointer travel across the nav.
     - ~250ms close delay lets the cursor move diagonally from the label down into
       the submenu without it closing prematurely.
     - Native <details> click toggle and keyboard (Tab + Enter/Space, focusout-close)
       are left fully intact for accessibility. */
  (function () {
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 250;
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    function setup() {
      document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
        var details = menu.querySelector('details');
        var summary = details && details.querySelector('summary');
        if (!details || !summary) return;
        var openTimer = null;
        var closeTimer = null;

        function openMenu() {
          // Keep a single top-level menu open at a time.
          document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(function (other) {
            if (other !== details) {
              other.removeAttribute('open');
              var otherSummary = other.querySelector('summary');
              if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
            }
          });
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }

        function closeMenu() {
          // menu.close() (HeaderMenu/DetailsDisclosure) clears [open] + aria-expanded.
          if (typeof menu.close === 'function') {
            menu.close();
          } else {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }

        menu.addEventListener('mouseenter', function () {
          if (!hoverCapable.matches) return;
          clearTimeout(closeTimer);
          if (details.open) return;
          openTimer = setTimeout(openMenu, OPEN_DELAY);
        });

        menu.addEventListener('mouseleave', function () {
          if (!hoverCapable.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () {
            // Don't yank it shut if a keyboard user is focused inside.
            if (!menu.contains(document.activeElement)) closeMenu();
          }, CLOSE_DELAY);
        });
      });
    }

    if (document.readyState !== 'loading') {
      setup();
    } else {
      document.addEventListener('DOMContentLoaded', setup);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
